module.exports = __webpack_public_path__ + "static/creditProducts-4ebcd5403ad3dab129dd1af55b80c197.jpg";